import { makeAutoObservable, runInAction } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  saveOrEditTreatmentPlanCard,
  pagingTreatmentPlanCard,
  getTreatmentPlanCardById,
  removeTreatmentPlanCard,
  getListPrepaidCard,
  getInitChangeTreatment,
  changeTreatment,
  unLockTreatment,
  lockTreatment,
} from "app/services/TreatmentPlanCardService";
import { pagingClientCard } from "app/services/ClientCardService";
import { RegisterCard } from "app/common/Model/RegisterCard";
import {
  CARD_PATIENT_STATUS,
  LEAD_SOURCE_LEVEL,
  PAGESIZE_ALL,
  TREATMENT_FREE,
  TYPE_CARD,
} from "app/common/LocalConst";
import { pagingPatientTransaction } from "app/services/PatientTransaction";
import { getPriceTypeService } from "app/common/LocalFunction";
import { elasticTreatmentPlanCardHistory } from "app/services/ElasticPatient";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingProgram } from "app/services/PromotionCRMService";

export default class RegisterCardStore {
  searchRegisterCard = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
    type: TYPE_CARD[0].value,
    orderDate: new Date(),
    chosenCards: [],
  };
  searchHistoryUsedCard = {
    ...new SearchObject(),
    prepaidCardId: null,
  };
  openConfirmDelete = null;
  openConfirmMessage = null;
  openConfirmMessageNotRemove = null;
  openAddCardAdvicePopup = false;
  openUpdateCardAdvicePopup = false;
  openChangeCardPopup = false;
  searchListCardAdvice = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
  };
  dataRegisterCard = [];
  pageRegisterCard = new PageResponse();
  openCreateOrEditCardPopup = false;
  initRegisterCard = { ...new RegisterCard() };
  pageHistoryUsedCard = new PageResponse();
  openHistoryUsedCard = false;
  initChangeCard = {
    oldTreatmentPlanCard: {
      ...new RegisterCard(),
    },
    newTreatmentPlanCard: {
      ...new RegisterCard(),
    },
  };
  treatmentFree = null;
  openConfirmLock = null;
  openConfirmUnlock = null;
  openHistoryCardPopup = false;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();

  openConfirmError = null
  constructor() {
    makeAutoObservable(this);
  }


  listCodeSource = [];
  handleGetListCodeSource = async (obj) => {
    try {
      const { data } = await getListCode(obj);
      runInAction(() => {
        this.listCodeSource = data || [];
      });
    } catch (error) {
      //console.error(error);
    }
  }

  pagingRegisterCard = async () => {
    let { orderDate, ...ortherData } = this.searchRegisterCard;
    return await pagingTreatmentPlanCard({
      ...ortherData,
      getStaffRevenues: true,
    })
      .then(({ data }) => {
        this.pageRegisterCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  pagingRegisterCardAdvice = async () => {
    return await getListPrepaidCard({
      ...this.searchListCardAdvice,
    })
      .then(({ data }) => {
        this.dataRegisterCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  saveOrUpdateRegisterCard = async (values) => {
    let { cardUsers, ...ortherData } = values;
    if (cardUsers && cardUsers?.length > 0) {
      ortherData.cardUsers = cardUsers?.map((el) => ({
        ...el,
        patient: { id: el?.patient?.id },
      }));
    }
    return await saveOrEditTreatmentPlanCard({ ...ortherData })
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return data;
        } else {
          toast.success("Đăng ký thẻ trả trước thành công");
          this.pagingRegisterCard();
          this.openCreateOrEditCardPopup = false;
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký thẻ trả trước có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterCard) => {
    this.searchRegisterCard = {
      ...this.searchRegisterCard,
      ...searchRegisterCard,
    };
    this.pagingRegisterCard();
  };

  handleChangeFormSearchCardAdvice = (obj) => {
    this.searchListCardAdvice = {
      ...this.searchListCardAdvice,
      ...obj,
    };
    this.pagingRegisterCardAdvice();
  };

  handleOpenCreateOrEditCardPopup = async (cardRegister, patient, defaultDepartment) => {
    let searchCodeSource = {};
    if (Boolean(cardRegister)) {
      getTreatmentPlanCardById(cardRegister?.id).then(async ({ data }) => {
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();
        data.totalAmount = data?.quantity * data?.price;

        // Fetch full CTKM data if promotionProgram exists (cần truyền productCode)
        if (data?.promotionProgram?.code && data?.clientCard?.code) {
          try {
            const { data: ctkmResponse } = await pagingProgram({
              codes: [data.promotionProgram.code],
              productCode: data.clientCard.code,
              pageSize: 10,
            });
            const fullCtkm = ctkmResponse?.content?.[0];
            if (fullCtkm) {
              data.promotionProgram = fullCtkm;
            }
          } catch (error) {
            console.error("Error fetching full CTKM data:", error);
          }
        }

        this.initRegisterCard = data;
        this.openCreateOrEditCardPopup = true;
        searchCodeSource = {
          visitId: this.initRegisterCard?.visit?.id,
          patientId: patient?.id || this.initRegisterCard?.patient?.id,
          departmentId: this.initRegisterCard?.department?.id,
          voucherIds: this.initRegisterCard?.voucherAllocations?.map(item => item?.voucher?.id) || [],
          invoiceItemIds: this.initRegisterCard?.invoiceItemAllocations?.map(item => item?.invoiceItem?.id) || []
        }
        this.handleGetListCodeSource(searchCodeSource)
      });
    } else {
      this.initRegisterCard = { ...new RegisterCard() };
      this.openCreateOrEditCardPopup = true;
      searchCodeSource = {
        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
        visitId: this.initRegisterCard?.visit?.id,
        startDate: this.initRegisterCard?.startDate || new Date(),
        patientId: patient?.id || this.initRegisterCard?.patient?.id,
        departmentId: defaultDepartment?.id,
      }
      this.handleGetListCodeSource(searchCodeSource)
    }
  };

  handleChangeFormSearchHistoryUsedCard = (searchObj) => {
    this.searchHistoryUsedCard = {
      ...this.searchHistoryUsedCard,
      ...searchObj,
    };
    this.getHistoryUsedCard();
  };

  getHistoryUsedCard = async () => {
    return await pagingPatientTransaction({ ...this.searchHistoryUsedCard })
      .then(({ data }) => {
        this.pageHistoryUsedCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử sử dụng thẻ trả trước có lỗi");
      });
  };

  handleOpenHistoryCardPopup = async (cardId) => {
    this.searchHistoryUsedCard = {
      ...this.searchHistoryUsedCard,
      prepaidCardId: cardId,
    };
    await this.getHistoryUsedCard();
    this.openHistoryUsedCard = true;
  };

  handleOpenAddCardAdvicePopup = async (obj) => {
    this.searchListCardAdvice = {
      ...this.searchListCardAdvice,
      ...obj,
    };
    this.pagingRegisterCardAdvice();
    this.openAddCardAdvicePopup = true;
  };

  handleAddCardAdvicePopup = async (data, patient, customerSourceWalkIn) => {
    let { clientCard, paiPatientTypeService, ...ortherData } = data;
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;

    let feeItem;
    if (paiPatientTypeService && clientCard?.clientCardFees?.length > 0) {
      feeItem = clientCard?.clientCardFees?.find(
        (el) => el?.patientTypeService?.id === paiPatientTypeService?.id
      );
    } else {
      feeItem =
        clientCard?.clientCardFees?.length > 0
          ? getPriceTypeService(
            data?.patientTypeService,
            clientCard?.clientCardFees
          )
          : null;
    }

    const price = feeItem?.price || clientCard?.totalNetPrice;

    ortherData.price = price;
    ortherData.priceWithTax = feeItem?.vatIncluded;
    ortherData.totalAmount = price * data?.quantity;
    ortherData.patientTypeService = {
      ...feeItem?.patientTypeService,
      price: feeItem?.price,
    };

    let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;
    ortherData.taxPercent = taxPercent;

    let taxTotal;
    if (feeItem?.vatIncluded) {
      taxTotal =
        ((feeItem?.price * data?.quantity - data?.discount) /
          (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotal =
        (feeItem?.price * data?.quantity - data?.discount) *
        ((+taxPercent || 0) / 100);
    }
    ortherData.taxTotal = taxTotal;

    let revenueAllocations = clientCard?.revenueAllocations;
    if (revenueAllocations) {
      let staffRevenues = revenueAllocations?.map((el) => ({
        position: el?.position,
        percentRevenue: el?.commissionRate,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        staff:
          currentConsultant?.position?.code === el?.position?.code
            ? currentConsultant
            : currentTelesale?.position?.code === el?.position?.code
              ? currentTelesale
              : null,
      }));
      console.log("staffRevenues", staffRevenues);

      ortherData.staffRevenues = staffRevenues;
    } else {
      ortherData.staffRevenues = [];
    }
    ortherData.cardUsers = [
      {
        patient: patient,
        userStatus: CARD_PATIENT_STATUS[0].value,
        isMainUser: true,
      },
    ];

    this.initRegisterCard = { ...ortherData, clientCard };
    this.openUpdateCardAdvicePopup = true;
  };

  saveOrUpdateCardAdvice = async (values) => {
    let { cardUsers, ...ortherData } = values;
    if (cardUsers && cardUsers?.length > 0) {
      ortherData.cardUsers = cardUsers?.map((el) => ({
        ...el,
        patient: { id: el?.patient?.id },
      }));
    }
    return await saveOrEditTreatmentPlanCard({ ...ortherData })
      .then(({ data }) => {
        this.openUpdateCardAdvicePopup = false;
        toast.success("Đăng ký thẻ trả trước từ tư vấn thành công");
        getListPrepaidCard(this.searchListCardAdvice).then(({ data }) => {
          this.dataRegisterCard = data;
        });
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký thẻ trả trước từ tư vấn có lỗi");
      });
  };

  handleCloseAddCardAdvicePopup = () => {
    this.openAddCardAdvicePopup = false;
    this.searchListTreatmentPlanAdvice = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };

  handleCloseUpdateCardAdvicePopup = () => {
    this.openUpdateCardAdvicePopup = false;
  };
  handleCloseHistoryUsedPopup = () => {
    this.openHistoryUsedCard = false;
    this.pageHistoryUsedCard = new PageResponse();
  };

  handleCloseCreateOrEditCardPopup = () => {
    this.openCreateOrEditCardPopup = false;
    this.initRegisterCard = { ...new RegisterCard() };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteCard = async () => {
    return await removeTreatmentPlanCard(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        this.openConfirmMessageNotRemove = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessageNotRemove = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Xóa thẻ trả trước thành công");
          this.pagingRegisterCard();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa thẻ trả trước có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  printContent = [];

  handleSetPrintContent = (printContent) => {
    this.printContent = printContent;
  };

  handleCloseConfirmMessageNotRemove = () => {
    this.openConfirmMessageNotRemove = null;
  };

  handleOpenChangeCardPopup = async (treatmentPlan, patient) => {
    try {
      let searchCodeSource = {};
      const { data } = await getInitChangeTreatment(treatmentPlan?.id);
      if (data) {
        let { oldTreatmentPlanCard } = data;
        let remainingAmount = oldTreatmentPlanCard?.remainingAmount;

        oldTreatmentPlanCard.remainingAmount = remainingAmount; // tổng tiền còn lại
        oldTreatmentPlanCard.oldTreatmentCredit = remainingAmount; // tiền khấu trừ lộ trình cũ

        // let formatStaffRevenues = oldTreatmentPlanCard?.staffRevenues?.map((el) => ({
        //   ...el,
        //   actualAmount: 0,
        //   oldPercentRevenue: el?.percentRevenue,
        // }));
        // oldTreatmentPlanCard.staffRevenues = formatStaffRevenues;

        // Không cần fetch CTKM cho old items vì chỉ hiển thị, không edit

        this.initChangeCard = {
          oldTreatmentPlanCard,
          ...new RegisterCard(),
          //staffRevenues: formatStaffRevenues,
          staffRevenues: [],
          oldTreatmentCredit: oldTreatmentPlanCard?.oldTreatmentCredit,
          price: 0,
          totalAmount: 0,
        };
        this.openChangeCardPopup = true;
        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          startDate: this.initChangeCard?.startDate || new Date(),
          patientId: patient?.id,
          departmentId: oldTreatmentPlanCard?.department?.id
        };
        this.handleGetListCodeSource(searchCodeSource);
      }
    } catch (error) {
      // if (error.response?.status === 403) {
      //   toast.error("Bạn không có quyền truy cập thông tin liệu trình");
      // } else {
      toast.error("Lấy thông tin liệu trình có lỗi");
      //}
    }
  };

  handleChangeCard = async (values) => {
    let { oldTreatmentPlanCard, stopTreatment, ...ortherData } = values;
    let obj = {
      oldTreatmentPlanCard,
    };
    if (!stopTreatment) {
      obj.newTreatmentPlanCard = ortherData;
    }
    try {
      const { data } = await changeTreatment(obj);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmMessage = data?.responseDetail;
        }, 500);
        return data;
      } else {
        this.openChangeCardPopup = false;
        toast.success("Đổi thẻ thành công");
      }
      this.pagingRegisterCard();
      return data;
    } catch (error) {
      console.error(error);
      toast.error("Đổi thẻ có lỗi");
    }
  };

  handleCloseChangeCardPopup = () => {
    this.openChangeCardPopup = false;
  };
  getTreatmentFree = async () => {
    return await pagingClientCard({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: TREATMENT_FREE,
      type: TYPE_CARD[1].value,
    })
      .then(({ data }) => {
        this.treatmentFree = data?.content?.[0];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu liệu trình tùy chỉnh có lỗi");
      });
  };

  handleConfirmLock = async () => {
    try {
      const { data } = await lockTreatment(this.openConfirmLock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Khóa thành công");
        this.pagingRegisterCard();
      }
      this.openConfirmLock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleConfirmUnlock = async () => {
    try {
      const { data } = await unLockTreatment(this.openConfirmUnlock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Mở khóa thành công");
        this.pagingRegisterCard();
      }
      this.openConfirmUnlock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenConfirmlock = (id) => {
    this.openConfirmLock = id;
  };

  handleCloseConfirmLock = () => {
    this.openConfirmLock = null;
  };

  handleOpenConfirmUnlock = (id) => {
    this.openConfirmUnlock = id;
  };

  handleCloseConfirmUnlock = () => {
    this.openConfirmUnlock = null;
  };

  handleCloseConfirm = () => {
    this.openConfirmError = null;
  };

  handleCloseHistoryCardPopup = async () => {
    this.openHistoryCardPopup = false;
    this.searchDataHistory = null;
  };

  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    return await elasticTreatmentPlanCardHistory({
      ...this.searchDataHistory,
    })
      .then(({ data }) => {
        this.pageDataHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử dịch vụ có lỗi");
      });
  };

  handleOpenHistoryMongoCardPopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryCardPopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  resetStore = () => {
    this.searchRegisterCard = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
      type: TYPE_CARD[0].value,
      orderDate: new Date(),
    };
    this.pageRegisterCard = new PageResponse();
    this.openCreateOrEditCardPopup = false;
    this.openConfirmMessage = null;
    this.openConfirmMessageNotRemove = null;
    this.initRegisterCard = { ...new RegisterCard() };
    this.printContent = [];
  };
}
